import { RefreshCw } from "lucide-react";
import type { Ref } from "react";

/** W47i (WI7): so lange bleiben „Passt“ und „Ablegen“ nach einem 409 `VORSCHLAG_GEAENDERT` gesperrt, damit ein
 *  Doppeltipp nicht den neuen Vorschlag ablegt, bevor er zu sehen ist. */
export const SPERRE_MS = 600;

/** W47i (WI4): Hinweis nach einem 409 `VORSCHLAG_GEAENDERT` in Karte und Prüfen-Blatt. Kein Fehlerrot, sondern die
 *  Warn-Toenung wie die allgemeinen Gruende im Blatt; Rolle `alert`, damit der Screenreader ihn sofort vorliest, und
 *  `tabIndex={-1}`, damit der Fokus dorthin wandern kann. Der Text ist der des Servers; darunter je geaendertem Wert eine
 *  Zeile „<Name>: jetzt <neu>, vorher <alt>“ (`aenderungen`). Wort und Liste tragen die Bedeutung, nicht die Farbe. */
/** `band`: in der Karte ueber die ganze Breite, direkt unter der Trennlinie (bei 320 px und 200 % bleibt so fuer jedes
 *  Wort der Zeilen eine ganze Zeile); sonst ein Kasten mit runden Ecken (Pruefen-Blatt). */
export function VorschlagGeaendertHinweis({ detail, zeilen, band = false, className, ref }: { detail: string; zeilen: string[]; band?: boolean; className?: string; ref?: Ref<HTMLDivElement> }) {
  return (
    <div
      ref={ref}
      role="alert"
      tabIndex={-1}
      data-testid="vorschlag.geaendert"
      className={`bg-pg-warn-soft px-4 py-3 outline-none ${band ? "" : "rounded-lg"} ${className ?? ""}`}
    >
      {/* Symbol im Textfluss, nicht als eigene Spalte: bei 320 px und 200 % braucht der Satz die ganze Breite (W47i E4) */}
      <p className="t-subheadline min-w-0 font-semibold break-words text-pg-warn">
        <RefreshCw size={16} strokeWidth={2} aria-hidden className="mr-2 inline-block shrink-0 align-middle" />
        {detail}
      </p>
      {zeilen.length > 0 && (
        // ohne Einzug: bei 320 px und 200 % bliebe sonst fuer „04.10.2026,“ keine ganze Zeile (gemessen 128 px). Lange
        // Woerter („Zahlungsaufforderung“) trennt die Zeile nach Silben mit Strich (`hyphens-auto`, wie das Band), nicht
        // irgendwo in der Silbe (Verifier W47i R1 A1)
        <ul aria-label="Geänderte Werte" className="t-footnote mt-2 flex list-none flex-col gap-1 text-pg-text">
          {zeilen.map((zeile) => (
            <li key={zeile} className="min-w-0 break-words hyphens-auto">
              {zeile}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
